"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmergencyNumber = exports.EmergencyNumbers = void 0;
exports.EmergencyNumbers = {
    SE: ['112', '113',],
};
const isEmergencyNumber = (number, alpha2) => {
    var _a;
    return (_a = exports.EmergencyNumbers[alpha2]) === null || _a === void 0 ? void 0 : _a.includes(number);
};
exports.isEmergencyNumber = isEmergencyNumber;
